<template>
  <gc-main-layout
    :title="title"
    :isXSmall="isXSmall"
    :isLarge="isLarge"
    :baseView="baseView"
    :key="baseView.mode"
    :formsConfig="formsConfig"
  >
    <template #headerContent>
      <GcHeaderContentStatic title="Reports" />
    </template>
    <div class="css-v2 reports-list" v-if="loading == false">
      <gc-split-view :showLeftContainer="true" :showRightContainer="true">
        <template #leftContent>
          <DxTreeView
            :data-source="userAccessibleReports"
            :select-by-click="true"
            selection-mode="single"
            @item-selection-changed="itemClick"
            :ref="'report-list-menu'"
            @content-ready="contentReady"
          />
        </template>

        <template #rightContent>
          <dx-data-grid
            :data-source="dataSourceConfig"
            :columns="columns"
            @selection-changed="onSelectionChanged"
            :height="gridHeight - 20"
            @content-ready="addGridNoResults($event)"
            :column-chooser="{ enabled: false }"
          >
            <DxPaging :page-size="50" :enabled="false" />
            <DxPager :visible="false" />

            <DxScrolling
              :mode="'virtual'"
              :row-rendering-mode="'virtual'"
              :preloadEnabled="true"
            />
            <template #report-title-cell-template="{ data }">
              <div class="report-title">
                <i :class="'dx-icon-' + data.data.icon"></i>
                <span>{{ data.data.name }}</span>
              </div>
            </template>
          </dx-data-grid>
        </template>
      </gc-split-view>
    </div>
  </gc-main-layout>
</template>

<script>
import BaseViewMixin from "../../v1/_mixins/base.view";
import { FeatureStorage } from "../../_services/storage";
// import { UserService } from "../../_services/api/Reports";
import { ScreenLayoutService } from "../../_services/api/reports/screen-layout.service";

var globalResponseRoutes = null; // HACK: but it works

export default {
  props: {},
  mixins: [BaseViewMixin],
  components: {},
  data() {
    return {
      responseRoutes: null,
      dataSourceConfig: [],
      userAccessibleReports: [],
      loading: true,
    };
  },
  async created() {
    if (globalResponseRoutes == null) {
      globalResponseRoutes = await ScreenLayoutService.getAllRouteOnly();
    }

    this.responseRoutes = globalResponseRoutes;

    let routes = this.responseRoutes.data.value;

    // add modules

    var modules = FeatureStorage.getItems()
      .filter(
        (x) =>
          x.WorkCentreApplicationFeatureCode == "ReportsWorkCentre" &&
          x.Type == "Module"
      )
      .sort((a) => a.ModuleSequence);

    modules.forEach((module) => {
      // alert(module.DisplayName);

      this.userAccessibleReports.push({
        id: this.userAccessibleReports.length + 1,
        text: module.DisplayName,
        category: `${module.DisplayName.toKebabCase()}`,
        path: `/${module.DisplayName.toKebabCase()}`,
        applicationFeatureCode: module.ModuleApplicationFeatureCode,
        reports: FeatureStorage.getItems()
          .filter(
            (x) =>
              x.ModuleApplicationFeatureCode == module.ApplicationFeatureCode
          )
          .sort((a) => a.DisplayName)
          .map((screen) => {
            let el = {};

            let screenLayout = routes.find(
              (a) => a.ApplicationFeatureCode == screen.ApplicationFeatureCode
            );

            let path = "";

            if (screenLayout) {
              path = `/${module.DisplayName.toKebabCase()}/${
                screen.Type == "Grid Report" ? "grid" : "form"
              }/${screenLayout.Route}`;
            }
            // HACK for old reports
            else if (
              screen.ApplicationFeatureCode == "ReportGeneralLedgerEnquiry"
            ) {
              path = "/general-ledger/summary";
            } else if (screen.ApplicationFeatureCode == "ReportInvoicedSales") {
              path = "/sales/invoiced-sales";
            }

            el.name = screen.DisplayName;
            el.icon =
              screen.Type == "Grid Report" ? "smalliconslayout" : "file";
            el.path = path;
            el.applicationFeatureCode = screen.ApplicationFeatureCode;
            return el;
          }),
      });
    });

    this.loading = false;
  },
  methods: {
    contentReady(e) {
      if (this.userAccessibleReports.length > 0) {
        if (!this.$route.params.category) {
          e.component.selectItem(this.userAccessibleReports[0].id);
          if (this.userAccessibleReports[0].text)
            document.title = "Reports - " + this.userAccessibleReports[0].text;
        } else {
          e.component.selectItem(
            this.userAccessibleReports.find(
              (x) => x.category == this.$route.params.category
            ).id
          );
          document.title =
            "Reports - " +
            this.userAccessibleReports.find(
              (x) => x.category == this.$route.params.category
            ).text;
        }
      }
    },
    itemClick(e) {
      if (e) {
        this.$logger.debug("e itemClick ", e);
        const selectedReports = e.component
          .getSelectedNodes()
          .map((node) => node.itemData);
        if (selectedReports.length > 0) {
          if (
            this.baseView.id.toLowerCase() !=
            selectedReports[0].text.toLowerCase()
          ) {
            this.$router
              .push({
                path: "/reports" + selectedReports[0].path,
              })
              .then(() => {
                document.title = "Reports - " + selectedReports[0].text;
              });
          }
          this.dataSourceConfig = selectedReports[0].reports;
        }

        // this.$logger.debug("selectedEmployees ", selectedReports);
      }
    },
    onSelectionChanged(e) {
      this.$logger.debug("e ", e);
      this.$logger.debug("baseview ", this.baseView);
      // if (e.selectedRowsData[0].name == "Sales Order") {
      this.$router.push({
        path: "/report" + e.selectedRowsData[0].path,
        query: {
          file: e.selectedRowsData[0].file,
        },
      });
    },
  },
  computed: {
    columns() {
      return this.parseGridColumns("master", [
        {
          gcLabel: "Report",
          dataField: "name",
          gcType: "String",
          gcSubType: "PrimaryRecord",
          cellTemplate: "report-title-cell-template",
          //   width: '100%'
        },
      ]);
    },
  },
};
</script>

<style lang="scss" >
.css-v2.reports-list {
  .dx-treeview-node-container .dx-treeview-node {
    margin: 0 !important;
  }
  .split-container-child.left-container {
    padding-left: 5px;
    padding-top: 10px;
    padding-bottom: 10px;
    border-radius: 3px;
  }

  .dx-widget.dx-collection.dx-treeview {
    background-color: white;
    border-radius: 3px;
  }

  .split-container-child.right-container {
    padding: 10px 10px 10px 0;
    border-left: unset !important;
  }
}
</style>
